import { type ValueOf } from '@/types';

export const OPEN_PAYMENT_SETUP_PARAM = 'open_payment_setup';

export const RequestToCancelSubscriptionEmail = 'pricing@scoro.com';
export const RequestToReduceSeatsEmail = 'pricing@scoro.com';
export const PageLoadingIllustration =
	'https://scoroassets.scoro.com/gfx/illustrations/img-self-service.svg';
export const ScoroPricingUrl = 'https://www.scoro.com/pricing';

export const ELI_BRAIN_CYCLES_SMALL_ADDON_CODE = 'eli_brain_cycles_small';
export const ELI_BRAIN_CYCLES_ADDON_CODE = 'eli_brain_cycles';
export const ADDITIONAL_ACCOUNTS_ADDON_CODE = 'additional_accounts';

export const DEFAULT_ADDON_ICON = 'list';
export const DEFAULT_CUSTOM_ADDON_ICON = 'custom';
export const CUSTOM_ADDONS_GROUP = 'custom';
export const NON_CUSTOM_ADDONS_GROUP = 'nonCustom';

//Old packages
export const LEGACY_TRIAL_PACKAGE_ID = '71';
export const PRO_PACKAGE_ID = '69';
export const ULTIMATE_PACKAGE_ID = '70';

//New packages
export const TRIAL_PACKAGE_2025_ID = '77';
export const CORE_PACKAGE_ID = '73';
export const GROWTH_PACKAGE_ID = '74';
export const PERFORMANCE_PACKAGE_ID = '75';
export const ENTERPRISE_PACKAGE_ID = '76';

export const ONB_STANDARD_25_ID = '584';
export const ONB_STANDARD_35_ID = '585';
export const ONB_CUSTOM_ID = '298';

// This is the same max limit that is set in PaymentDetailsService
export const SELF_SERVICE_MAX_SEAT_COUNT = 10000;

export const SelfServiceAddonIcon: { [key: string]: string } = {
	// Work & collaboration
	projectPhases: 'phase',
	timeTracker: 'stopwatch',
	projectTemplates: 'bar',
	taskMatrix: 'board',
	planningMode: 'planner',
	customer_portal: 'external',
	timesheet: 'sheet',
	projectsTimeline: 'timeline',
	customization: 'custom',
	calendar_resource_management: 'people',
	customPdfCssStyle: 'view',

	// Sales & finance
	pipeline: 'board',
	partialInvoicing: 'paper-coins',
	budgets: 'budget',
	quotes_templates: 'bar',
	scheduledInvoices: 'circlearrow',
	creditManagement: 'paper-clock', // Invoice reminders
	priceLists: 'list',

	// General & Reporting
	pipelineReport: 'chart',
	wipReport: 'chart',

	// Integrations
	xero_sync: 'xero',
	quickbook_sync: 'quickbooks',
	expensify_sync: 'expensify',
	exactOnline: 'exact',
	googleDocs: 'google-drive',
	dropbox: 'dropbox',
} as const;

export const SelfServiceAddonIconLarge: { [key: string]: string } = {
	...SelfServiceAddonIcon,
	pipelineReport: 'chart-filled',
	wipReport: 'chart-filled',
} as const;

export const SelfServicePlanSummaryVariant = {
	Paying: 'paying',
	Trialist: 'trialist',
} as const;

export type SelfServicePlanSummaryVariant = ValueOf<
	typeof SelfServicePlanSummaryVariant
>;
